export const TRAFFIC_SOURCE = {
  EXTERNAL_DEEPLINK_WEB_COPY_CREATOR: 'wccr',
  EXTERNAL_DEEPLINK_WEB_COPY_CONTRIBUTOR: 'wcco',
  EXTERNAL_DEEPLINK_NATIVE_SHARE_CREATOR: 'wncr',
  EXTERNAL_DEEPLINK_NATIVE_SHARE_CONTRIBUTOR: 'wnco',
  EXTERNAL_DEEPLINK_APP_COPY_CREATOR: 'accr',
  EXTERNAL_DEEPLINK_APP_COPY_CONTRIBUTOR: 'acco',
  EXTERNAL_DEEPLINK_APP_NATIVE_SHARE_CREATOR: 'ancr',
  EXTERNAL_DEEPLINK_APP_NATIVE_SHARE_CONTRIBUTOR: 'anco',
  EXTERNAL_DEEPLINK_UPDATE_EMAIL: 'ue',
}
